import { Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import moment from 'moment';
// Services
import { DocumentsService } from '../_services/documents.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PdfService } from '../_services/pdf.service';
// Models
import { DocumentTable } from '../_models/document';
import { FilterService } from '../_services/filter.service';
import { DeleteConfirmationComponent } from '../delete-confirmation/delete-confirmation.component';
import { Subscription } from 'rxjs';
import { AppService } from '../_services/app.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { User } from '../_models/user';
import { AuthService } from '../_services/auth.service';
import { ErrorDiagnosticService } from '../_services/error-diagnostic.service';

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  currentUser: User;
  documentsTable: DocumentTable[] = null;
  withResults: boolean = false;
  documents: Array<object>;
  pdfs: Array<Object> = [];
  pdfToPrint: string;
  loading: boolean = false;
  checkedDocumentsReq$: Subscription;
  confirmationType: string = '';
  showAppDocuments: boolean = false;
  pdfTemp = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  

  @ViewChild('iframe') iframe: ElementRef;
  @ViewChild(DeleteConfirmationComponent) private deletePopUp: DeleteConfirmationComponent;
  @ViewChild(ConfirmationModalComponent) private confirmModal: ConfirmationModalComponent;
  @ViewChild('mailSender', { static: true }) mailSender;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;

  constructor(
    private diagnosticService: ErrorDiagnosticService,
    private documentsService: DocumentsService,
    private location: Location,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private pdfService: PdfService,
    private renderer: Renderer2,
    private filterService: FilterService,
    private appService: AppService,
    private errorDiagnosticService: ErrorDiagnosticService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnDestroy(): void {
    if (this.checkedDocumentsReq$) {
      this.checkedDocumentsReq$.unsubscribe();
    }
  }

  ngOnInit() {
    this.diagnosticService.setMethodName("Search-Document-list");

    this.retrieveUserData();
    this.loadDocuments();
  }

  retrieveUserData() {
    this.currentUser = JSON.parse(localStorage.getItem("user"));
  }

  loadDocuments() {
    const checked = this.documentsService.getDocumentsValue().filter(d => d.checked).map(d => d.Id);

    let requestConfig = this.filterService.getFiltersRequest();
    if (!requestConfig) {
      requestConfig = {
        ...requestConfig, ...{
          filters: [],
          fromDate: moment().format(),
          signed: 0,
          toDate: moment().format(),
          scan: ""
        }
      };
    }
    this.documentsService.getDocuments(requestConfig).subscribe(data => {
      if (checked.length > 0) {
        checked.forEach(id => {
          const document = data.find(d => d.Id === id);
          if (document) document.checked = true;
        });
      }

      this.documents = data;
      if (data.length < 1)
        this.toastr.info(this.translateService.instant('search.empty_results.description'), this.translateService.instant('search.empty_results.title'), { closeButton: true, timeOut: 6000, progressBar: true, enableHtml: true })
      else{
        this.showAppDocuments = true;
        this.cdr.detectChanges();
      }
    },
      err => {
        this.toastr.error(err, this.translateService.instant('error.title'));
      });
  }

  filterSigned(type: string = '') {
    const filteredDocs = this.pdfs;
    if (filteredDocs.length < this.pdfs.length) {
      this.toastr.info(this.translateService.instant(`components.${type}.not_signed`));
    }
    return filteredDocs;
  }

  public handleButtonAction(btn) {
    const { action } = btn;
    switch (action) {
      case 'sign':
        this.router.navigateByUrl('/sign');
        break;
      case 'download':
      case 'print':
        this.documentsService.getDocumentsPdf(action === 'print' ? true : false).subscribe(async data => {
          this.pdfs = data;
          const filteredDocs = this.filterSigned(action);
          if (!!!filteredDocs.length) return;

          if (action === 'download') {
            this.pdfService.downloadPdfs(filteredDocs);
          } else {
            const blob = await this.pdfService.getPdfBlobForPrinting(filteredDocs);
            this.pdfToPrint = URL.createObjectURL(blob as Blob);

            if (this.appService.mobileCheck()) {
              this.toastr.info(this.translateService.instant('components.print.downloading_doc'));
              window.open(this.pdfToPrint);
            }
            else if (typeof window["InstallTrigger"] !== 'undefined') {
              this.pdfViewerOnDemand.pdfSrc = this.pdfToPrint;
              this.pdfViewerOnDemand.refresh();
            }
            else if (window.document['documentMode']) {
              (window.navigator as any).msSaveOrOpenBlob(blob);
            }
            else {
              this.cdr.detectChanges();
              this.renderer.listen(this.iframe.nativeElement, 'load', (e) => {
                this.iframe.nativeElement.contentWindow.print();
              });
            }
          }
        }, err => {
          this.toastr.error(this.translateService.instant(action === 'download' ? 'search.download_request_error' : 'search.print_request_error'));
        });
        break;
      case 'email':
        const docIds = this.documentsService.getCheckedDocIds();
        if (!!docIds.length) {
          this.mailSender.open();
        } else {
          this.toastr.info(this.translateService.instant('mail_sender.cannot_send'));
        }
        break;
      case 'delete':
        this.documentsService.getCheckedDocuments().subscribe(data => {
        this.withResults= data.filter(d => d['Signed']).length > 0 ;
        });
    
        this.deletePopUp.open();
        break;
      case 'reject':
        this.toastr.info(this.translateService.instant('comingSoon'));
        // this.confirmationType = 'reject';
        // this.confirmModal.open();
        break;
    }
  }

  sendDocs(mails) {
    this.loading = true;
    this.documentsService.emailSend(mails).subscribe(data => {
      this.loading = false;
      this.toastr.success(this.translateService.instant('mail_sender.success_send'));
      this.mailSender.close();
    }, err => {
      this.loading = false;
      this.toastr.error(this.translateService.instant(err));
    });
  }

  // Delete functionallity
  deleteDocumentsSign(event) {
    this.checkedDocumentsReq$ = this.documentsService.getCheckedDocuments().subscribe(docs => {
      const ids = docs.map(d => { return d.Id });
      this.documentsService.deleteDocuments(ids).subscribe(response => {
        this.deletePopUp.close();
        this.loadDocuments();
        
        const message = this.getSucessMessage(response);
        if (response.Success && response.Success.length) {
          this.toastr.success(message, '', { closeButton: true, timeOut: 6000, progressBar: true, enableHtml: true })
        } else {
          this.toastr.info(message, '', { closeButton: true, timeOut: 6000, progressBar: true, enableHtml: true })
        }
      },
        err => {
          this.deletePopUp.close();
          this.toastr.error(this.translateService.instant('delete_popup.request_error'));
        });
    });
  }

  onConfirm(e) {
    switch (this.confirmationType) {
      case 'reject':
        this.rejectDoc();
        break;
    }
  }

  rejectDoc() {
    this.checkedDocumentsReq$ = this.documentsService.getCheckedDocuments().subscribe(docs => {
      const docFilter = docs.filter(d => ['signed', 'rejected'].includes(d.Status) || !d.Signers.find(s => this.authService.compareUsr(s)));
      if (docFilter.length < docs.length) {
        this.toastr.error(this.translateService.instant('popup.reject.cannot_reject'));
        this.confirmModal.close();
        this.confirmationType = '';
        return;
      }

      const ids = docs.map(d => { return d.Id });
      this.documentsService.rejectDocs(ids).subscribe(response => {
        this.confirmationType = '';
        this.confirmModal.close();
        this.loadDocuments();
        this.toastr.success(this.translateService.instant('popup.reject.success'));
      },
        err => {
          this.confirmModal.close();
          this.toastr.error(this.translateService.instant('popup.reject.request_error'));
        });
    });
  }

  private getSucessMessage(response) {
    const failedDocs = this.getDocNames(response.Failed);
    const sucessDocs = this.getDocNames(response.Success);
    return `${sucessDocs.length ? this.translateService.instant('delete_popup.success') + sucessDocs.toString() + '</br>' : ''}
            ${failedDocs.length ? this.translateService.instant('delete_popup.failed') + failedDocs.toString() : ''}`
  }

  private getDocNames(docsIds: Array<number>) {
    const docs = this.documentsService.getDocumentsValue().filter(d => docsIds.indexOf(d.Id) > -1);
    return docs.map(d => { return ` ${d.OD}-${d.ODItems[0]?.MaterialDescription}-${d.DocumentType}` });
  }

  
  showDocuments(){
   /*  let rpta  = this.documents != null && this.documents.length > 0
    console.log("mostrar Docs", rpta); */
    return this.documents != null && this.documents.length;
  }
}
